import { useMemo } from "react";

export interface NotionSourceSettingsText {
  importTodosLabelText: string;
  importTodosHintText: string;
  pagesLabelText: string;
  pagesPlaceholderText: string;
  pagesHintText: string;
  pagesSearchPlaceholderText: string;
  mentionsUserLabelText: string;
  loadingPagesText: string;
  loadErrorText: string;
}

export const useNotionSourceSettingsText = (
  t: (key: string) => string,
): NotionSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.notion.${key}`);

    return {
      importTodosLabelText: tKey("importTodosLabel"),
      importTodosHintText: tKey("importTodosHint"),
      pagesLabelText: tKey("pagesLabel"),
      pagesPlaceholderText: tKey("pagesPlaceholder"),
      pagesHintText: tKey("pagesHint"),
      pagesSearchPlaceholderText: tKey("pagesSearchPlaceholder"),
      mentionsUserLabelText: tKey("mentionsUserLabel"),
      loadingPagesText: tKey("loadingPages"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
